import "./style.css";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import jwtDecode from "jwt-decode";
import MyPageBookings from "./_components/bookings";
import Notifications from "./_components/notification/Notifications";
import Quotations from "./_components/quotations";
import AccountInformation from "./_components/account/AccountInformation";
import InvoiceAndBIlling from "./_components/invoiceAndBilling/InvoiceAndBilling";
import BussinessAccountInformation from "./_components/account/BussinessAccountInformation";
import { Link, useLocation, useParams } from "react-router-dom";
import NotificationDetail from "./_components/notification/NotificationDetail";
import { useTranslation } from "react-i18next";
import { myPageMenu } from "../../../utils/dataLists"
import { newGetBookings } from "../../../actions/auth/booking";

const CustomerMyPage = (props) => {
  const [subPage, setSubPage] = useState("Bookings");
  const [page, setPage] = useState("Bookings");
  const [userInfo, setUserInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const { notif_id } = useParams();
  const notifId = notif_id;
  const { t } = useTranslation();
  const state = props?.location?.state;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedJwt = jwtDecode(token);
      setUserInfo(decodedJwt.user);
    }

    switch (location.pathname) {
      case "/my-page/bookings":
        setSubPage(t('my_page.tab_bookings'));
        break;
      case "/my-page/quotations":
        setSubPage(t('my_page.tab_bookings'));
        break;
      case "/my-page/notifications":
        setSubPage(t('my_page.tab_notifications'));
        break;
      case "/my-page/account":
        setSubPage(t('my_page.tab_accounts'));
        break;

      default:
        break;
    }
    setIsLoading(false);
  }, [location]);

  const renderPage = () => {
    switch (location.pathname) {
      case "/my-page/bookings":
        return <MyPageBookings userRole={userInfo.role} />;
      case "/my-page/quotations":
        return <Quotations />;
      case "/my-page/notifications":
        return <Notifications />;
      case "/my-page/notifications/" + notifId:
        return <NotificationDetail />; // this will change to botification detail
      case "/my-page/account":
        // Wait for the role: rendering the individual page first for a business
        // user made it load and crash on data that business accounts don't have.
        if (isLoading) return null;
        return userInfo.role === "business" ? (
          <BussinessAccountInformation state={state} />
        ) : (
          <AccountInformation state={state} />
        );
      case "/my-page/invoices-billings":
        return !isLoading && userInfo.role === "business" ? (
          <InvoiceAndBIlling />
        ) : (
          <></>
        );
      default:
        return <MyPageBookings userRole={userInfo.role} />;
    }
  };

  return (
    <FrontLayout>
      <div className="bg-my-page">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mt-1 tw:pt-1 tw:px-0 tw:lg:px-2">
          <div className="custom-mx">
            <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:!mt-8 tw:lg:w-full tw:lg:flex-none tw:px-0 tw:lg:px-2">
              <div className="tw:px-6 tw:lg:px-0 tw:pb-6">
                <h2 className="tw:font-libre-caslon-display tw:text-[34px] tw:font-normal tw:leading-[45px] tw:text-[#212529]">{t('my_page.title')}</h2>
              </div>
              <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-layout-myPage">
                {/* DESTOP VIEW */}
                <div className="tw:flex-1 tw:pt-2 bb-1 tw:p-0">
                  <ul className="tw:flex tw:flex-nowrap tw:!pl-0 tw:mb-0 tw:list-none tw:flex-row tw:w-full tw:items-stretch tw:h-16 tw:border-b tw:border-[#F1F1F1] tw:overflow-x-auto">
                    {myPageMenu[userInfo.role]?.map((val) => (
                      <li
                        key={val.link}
                        className={`tw:whitespace-nowrap tw:flex tw:w-auto tw:flex-1 tw:items-center tw:justify-center tw:border-b tw:px-4 tw:md:px-8 tw:py-0 ${location.pathname === val.link ? "active tw:border-[#282828] tw:border-b-[2.5px]" : "tw:border-[#E8E8E8]"}`}
                      >
                        <Link
                          to={`${val.link}${val.defaultParams}`}
                          className={`tw:text-[#212529]! tw:flex tw:h-full tw:w-full tw:items-center tw:justify-center tw:font-hanken-grotesk tw:leading-[22px] tw:!no-underline ${location.pathname === val.link ? "tw:text-[16px] tw:font-bold tw:text-[#282828]" : "tw:text-[15px] tw:font-normal tw:text-[#4E4E4E]"}`}
                        >
                          {t(val.tag)}
                        </Link>
                      </li>
                    )
                    )}
                  </ul>
                </div>

                {/* TAB CONTENT  */}
                <div className="tw:flex-1 tw:p-0 tw:m-0">
                  {renderPage()}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};
export default CustomerMyPage;
